import React, { useState, useEffect } from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import form from "../../assets/medical/form.jpg";
import { useNavigate } from "react-router-dom";
import { useCreateMedicalContactMutation } from '../../store/api/contact'; // Import the mutation

const Visa = () => {
    const navigate = useNavigate();

    // Add the mutation hook
    const [createMedicalContact, { isLoading, isSuccess, error }] = useCreateMedicalContactMutation();

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [formData, setFormData] = useState({
        fullName: '',
        phoneNumber: '',
        address: '',
        age: '',
        gender: '',
        quotation: '',
        condiotionsandneeds: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        setSelectedFiles((prev) => [...prev, ...files]);
    };

    const handleRemoveFile = (index) => {
        setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    };
    const [showSuccess, setShowSuccess] = useState(false);

    useEffect(() => {
        if (isSuccess) {
            setShowSuccess(true);
            const timer = setTimeout(() => setShowSuccess(false), 3000); // Hide after 3s
            return () => clearTimeout(timer);
        }
    }, [isSuccess]);

    // Update the handleSubmit function to use the API
    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append("full_name", formData.fullName);
        data.append("phone_number", formData.phoneNumber);
        data.append("address", formData.address);
        data.append("age", formData.age);
        data.append("gender", formData.gender);
        data.append("quotation", formData.quotation);
        data.append("conditions_and_needs", formData.condiotionsandneeds);

        // Append multiple files
        selectedFiles.forEach((file) => {
            data.append("files", file);
        });

        try {
            const res = await createMedicalContact(data).unwrap();
            console.log("✅ Successfully submitted:", res);
       

            // Reset form
            setFormData({
                fullName: '',
                phoneNumber: '',
                address: '',
                age: '',
                gender: '',
                quotation: '',
                condiotionsandneeds: '',
            });
            setSelectedFiles([]);

            // Optionally navigate to another page after success
            // navigate('/success-page');

        } catch (err) {
            console.error("❌ Submission failed:", err);
            alert("Submission failed. Please try again.");
        }
    };

    return (
        <section>
            <div className="py-24 px-8">
                <div className="min-h-screen flex items-center justify-center">
                    <div className="bg-[#FFFBF4] rounded-tr-[40px] rounded-bl-[40px] shadow-lg max-w-6xl w-full">
                        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
                            <div className="md:flex md:flex-col md:justify-center px-4 py-4 md:px-10 md:py-0 mb-5">
                                <div className="flex justify-start mb-12">
                                    <button
                                        type="button"
                                        onClick={() => { navigate('/medical') }}
                                        className="bg-[#5B656F] hover:bg-[#3a4558] text-white text-sm md:text-sm font-medium md:py-2 py-2 md:px-4 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-1 md:gap-2"
                                    >
                                        <MdOutlineKeyboardBackspace className="text-base md:text-sm" />
                                        Back
                                    </button>
                                </div>

                                <h1 className="md:text-3xl text-2xl font-bold font-[Raleway] text-gray-900 mb-2">
                                    Medical Information Request
                                </h1>
                                <p className="text-gray-600 mb-8 font-[Rufina]">
                                    Help us understand needs better.
                                </p>

                                {/* Show loading state */}
                                {isLoading && (
                                    <div className="mb-4 p-3 bg-blue-100 text-blue-700 rounded-lg">
                                        Submitting your form...
                                    </div>
                                )}



                                <form onSubmit={handleSubmit} className="space-y-6 font-[Raleway]">
                                    <div className="grid sm:grid-cols-2 gap-4">
                                        <div className="relative">
                                            <input
                                                type="text"
                                                name="fullName"
                                                value={formData.fullName}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                required
                                                disabled={isLoading} // Disable during loading
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Full Name
                                            </label>
                                        </div>
                                        <div className="relative">
                                            <input
                                                type="tel"
                                                name="phoneNumber"
                                                value={formData.phoneNumber}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                required
                                                disabled={isLoading}
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Phone Number
                                            </label>
                                        </div>
                                    </div>
                                    <div className='grid sm:grid-cols-2 gap-4'>
                                        <div className="relative">
                                            <input
                                                type="text"
                                                name="address"
                                                value={formData.address}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                required
                                                disabled={isLoading}
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Address
                                            </label>
                                        </div>
                                        <div className="grid sm:grid-cols-2 gap-4">
                                            <div className="relative">
                                                <input
                                                    type="number"
                                                    name="age"
                                                    value={formData.age}
                                                    onChange={handleChange}
                                                    className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                    required
                                                    disabled={isLoading}
                                                />
                                                <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                    Age
                                                </label>
                                            </div>
                                            <div className="relative">
                                                <select
                                                    name="gender"
                                                    value={formData.gender}
                                                    onChange={handleChange}
                                                    className="w-full border border-gray-300 rounded-lg bg-white focus:outline-none focus:border-gray-600 px-3 py-3 text-[10px] appearance-none"
                                                    required
                                                    disabled={isLoading}
                                                >
                                                    <option value="">Select Gender</option>
                                                    <option value="male">Male</option>
                                                    <option value="female">Female</option>
                                                    <option value="other">Other</option>
                                                </select>
                                                <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                    Gender
                                                </label>
                                                <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                                    <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <fieldset className="grid gap-2">
                                        <legend className="text-gray-600 text-[10px] md:text-[12px] mb-1">
                                            Would you like a quotation?
                                        </legend>
                                        <div className="flex gap-3">
                                            <button
                                                type="button"
                                                onClick={() => setFormData({ ...formData, quotation: 'yes' })}
                                                disabled={isLoading}
                                                className={`px-3 py-1 rounded-md text-[10px] md:text-[12px] border transition-colors duration-200 
                                                ${formData.quotation === 'yes'
                                                        ? 'bg-[#5B656F] text-white border-[#5B656F]'
                                                        : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-100'}
                                                ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                            >
                                                Yes
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => setFormData({ ...formData, quotation: 'no' })}
                                                disabled={isLoading}
                                                className={`px-3 py-1 rounded-md text-[10px] md:text-[12px] border transition-colors duration-200 
                                                ${formData.quotation === 'no'
                                                        ? 'bg-[#5B656F] text-white border-[#5B656F]'
                                                        : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-100'}
                                                ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                            >
                                                No
                                            </button>
                                        </div>
                                    </fieldset>
                                    <div className="relative">
                                        <input
                                            type="file"
                                            id="fileUpload"
                                            multiple
                                            onChange={handleFileChange}
                                            className="hidden"
                                            disabled={isLoading}
                                        />
                                        <div
                                            onClick={() => !isLoading && document.getElementById("fileUpload").click()}
                                            className={`w-full border border-dotted rounded-lg focus:outline-none px-3 py-6 text-[10px] text-gray-500 cursor-pointer hover:bg-gray-50 transition relative
                                            ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                            style={{ borderWidth: "2px", borderColor: "#ccc", borderStyle: "dotted" }}
                                        >
                                            {selectedFiles.length === 0 ? (
                                                <p className="text-center text-gray-400 text-xs">
                                                    Click here to upload previous medical reports (if any)
                                                </p>
                                            ) : (
                                                <div className="flex flex-wrap gap-3 justify-start">
                                                    {selectedFiles.map((file, index) => (
                                                        <div
                                                            key={index}
                                                            className="relative border p-2 rounded-md w-20 h-20 flex items-center justify-center text-[10px] text-gray-600"
                                                        >
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleRemoveFile(index);
                                                                }}
                                                                disabled={isLoading}
                                                                className="absolute -top-2 -right-2 bg-gray-200 hover:bg-red-500 text-gray-600 hover:text-white rounded-full w-5 h-5 flex items-center justify-center text-[10px] shadow"
                                                            >
                                                                ✕
                                                            </button>
                                                            {file.type.startsWith("image/") ? (
                                                                <img
                                                                    src={URL.createObjectURL(file)}
                                                                    alt={file.name}
                                                                    className="w-full h-full object-cover rounded-md"
                                                                />
                                                            ) : file.type === "application/pdf" ? (
                                                                <div className="text-center text-[10px] flex flex-col items-center justify-center">
                                                                    <i className="fa-solid fa-file-pdf text-red-500 text-lg"></i>
                                                                    <p className="truncate w-14">{file.name}</p>
                                                                </div>
                                                            ) : (
                                                                <p className="truncate">{file.name}</p>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                        <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                            Upload previous medical reports (if any)
                                        </label>
                                    </div>

                                    <div className="relative">
                                        <textarea
                                            name="condiotionsandneeds"
                                            value={formData.condiotionsandneeds}
                                            onChange={handleChange}
                                            placeholder='Please provide as much details as possible about your medical condition and what you are looking for.'
                                            rows="2"
                                            className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px] resize-none"
                                            disabled={isLoading}
                                        />
                                        <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                            Describe your condition and needs
                                        </label>
                                    </div>
                                     {error && (
                                    <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg">
                                        Error: {error.data?.message || "Submission failed"}
                                    </div>
                                )}
                                    {showSuccess && (
                                        <div className="mb-4 p-3 bg-green-100 text-green-700 text-center rounded-lg">
                                            Form submitted successfully!
                                        </div>
                                    )}

                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        className={`w-full bg-[#5B656F] hover:bg-[#3a4558] text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2
                                        ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    >
                                        {isLoading ? 'Submitting...' : 'Submit Application'}
                                        <FiArrowUpRight className="text-xl" />
                                    </button>
                                </form>
                            </div>
                            <div className="hidden lg:flex items-center justify-center">
                                <div className="relative w-full h-full min-h-[400px]">
                                    <img
                                        src={form}
                                        alt="Travel form"
                                        className="w-full h-full object-cover rounded-tr-[40px]"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Visa;